module.exports = __webpack_public_path__ + "img/tpc-22.d0e128ac.jpg";